import axios from 'axios';

// Create a base axios instance with configuration
const api = axios.create({
  // Use relative path for API requests when served from the same origin
  baseURL: '/api', 
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for adding auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    const currentToken = localStorage.getItem('token');

    // A late response from an older session must not invalidate a new login.
    if (error.response?.status === 401 && currentToken &&
        originalRequest?.headers?.Authorization === `Bearer ${currentToken}`) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        window.location.replace('/login');
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
